<template>
  <div class="authorize">
    <div class="authorize-content">
      <div class="authorize-img">
        <img src="https://chuangpei-prod.oss-cn-hangzhou.aliyuncs.com/images/png_waibushouquan%402x.png">
      </div>
      <div class="authorize-text mg-top32">该页面使用外部授权，请使用外部授权入口进入观看</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'authorize',
    data() {
      return {}
    },
    computed: {
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/styles/variables.scss";

  .authorize{
    position: relative;
    height: 100%;
    .authorize-content{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .authorize-img{
        width: 460px;
        img{
          width: 100%;
          display: block;
        }
      }
      .authorize-text{
        font-size: 16px;
        color: #333;
        text-align: center;
      }
    }
  }
</style>
